/**
 * @experimental This icon will be moved to a separate icon package.
 * Use only when referencing Managed Risk services/products.
 */
export const ManagedRiskIcon = ({
  color = 'currentcolor',
}: {
  color?: string;
}) => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.30389 4.08691H4.3272C4.14724 4.08691 4 4.23415 4 4.41411V9.31554C4 9.4955 4.14724 9.64274 4.3272 9.64274C4.50716 9.64274 4.6544 9.4955 4.6544 9.31554V4.74131H9.30389C9.48384 4.74131 9.63108 4.59407 9.63108 4.41411C9.63108 4.23415 9.48384 4.08691 9.30389 4.08691Z"
        fill={color}
      />
      <path
        d="M19.6728 4.08691H14.6961C14.5161 4.08691 14.3689 4.23415 14.3689 4.41411C14.3689 4.59407 14.5161 4.74131 14.6961 4.74131H19.3456V9.31554C19.3456 9.4955 19.4928 9.64274 19.6728 9.64274C19.8527 9.64274 20 9.4955 20 9.31554V4.41411C20 4.23415 19.8527 4.08691 19.6728 4.08691Z"
        fill={color}
      />
      <path
        d="M9.30389 19.2558H4.6544V14.6816C4.6544 14.5016 4.50716 14.3544 4.3272 14.3544C4.14724 14.3544 4 14.5016 4 14.6816V19.583C4 19.763 4.14724 19.9102 4.3272 19.9102H9.30389C9.48384 19.9102 9.63108 19.763 9.63108 19.583C9.63108 19.403 9.48384 19.2558 9.30389 19.2558Z"
        fill={color}
      />
      <path
        d="M19.6728 14.3577C19.4928 14.3577 19.3456 14.5049 19.3456 14.6849V19.2591H14.6961C14.5161 19.2591 14.3689 19.4063 14.3689 19.5863C14.3689 19.7663 14.5161 19.9135 14.6961 19.9135H19.6728C19.8527 19.9135 20 19.7663 20 19.5863V14.6849C20 14.5049 19.8527 14.3577 19.6728 14.3577Z"
        fill={color}
      />
      <path
        d="M14.2543 10.9483H12.602C12.5398 10.9483 12.5038 10.8828 12.53 10.8305L14.0187 8.02313C14.0482 7.97077 14.0089 7.90533 13.9468 7.90533H11.3619C11.3259 7.90533 11.2965 7.92824 11.2866 7.96096L9.8895 12.2342C9.87314 12.2865 9.9124 12.3389 9.96475 12.3389H11.4437C11.4993 12.3389 11.5386 12.3945 11.5189 12.4468L10.1316 16.4223C10.1022 16.5107 10.2167 16.5728 10.2723 16.4976L14.3165 11.0792C14.3558 11.0268 14.3165 10.9516 14.2511 10.9516L14.2543 10.9483Z"
        fill={color}
      />
    </svg>
  );
};
